module.exports = __webpack_public_path__ + "img/bus-g.0e6de143.png";